import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Headings } from "../../atoms/Headings";
import "./summary-of-changes.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import {
  addCommas,
  contributionEffectiveDateMonthYear,
} from "../../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import LoadingSpinner from "../../atoms/Loader";
const SummaryOfChangesModal = (props) => {
  const { fetching, data, error } = useSelector((state) => state.postManage); // eslint-disable-line no-unused-vars
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const { postContributionRates } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );
  let initialYouContribPice = 0;
  if (props.isSelectedItem?.salarySacrificeFlag) {
    initialYouContribPice =
      (props.isSelectedItem?.annualPensionableSalary / 12) *
      ((parseFloat(props.isSelectedItem?.potPercentage) +
        parseFloat(props.isSelectedItem?.salarySacrificePercentage)) /
        100);
  } else {
    initialYouContribPice =
      (props.isSelectedItem?.annualPensionableSalary / 12) *
      (props.isSelectedItem?.potPercentage / 100);
  }
  const initialEmpContribPrice =
    (props.isSelectedItem?.annualPensionableSalary / 12) *
    (props.isSelectedItem?.potErPercentage / 100);
  const initialTotalContribution =
    initialYouContribPice + initialEmpContribPrice;
  const initialYouPayValue =
    initialYouContribPice -
    Math.round(initialYouContribPice * props.govtSupportPercentage);

  const initialAVContributionValue = props.isSelectedItem?.avcPercentage
    ? (props.isSelectedItem?.annualPensionableSalary / 12) *
      (props.isSelectedItem?.avcPercentage / 100)
    : props.isSelectedItem?.avcValue;

  const initialTotalAVContributionPrice = props.isSelectedItem?.avcPercentage
    ? initialTotalContribution +
      (props.isSelectedItem?.annualPensionableSalary / 12) *
        (props.isSelectedItem?.avcPercentage / 100)
    : initialTotalContribution + parseInt(initialAVContributionValue);

  const initialYouPayAVCValue = props.isSelectedItem?.avcPercentage
    ? initialYouPayValue +
      (props.isSelectedItem?.annualPensionableSalary / 12) *
        (props.isSelectedItem?.avcPercentage / 100)
    : initialYouPayValue + parseInt(initialAVContributionValue);
  const handleSubmit = () => {
    const payload = {
      employeeAvcFixedPercent: props.avcPercentageValue,
      employeeFixedPercent: props.contributionValue,
      employerAvcFixedPercent: props.isSelectedItem?.employerAvcPercentage,
      employerFixedPercent: props.contributionErValue,
      salSacrificeFixedPercent: props.isSelectedItem?.salarySacrificeFlag
        ? props.salarySacrificeContribution.toString()
        : props.isSelectedItem?.salarySacrificePercentage?.toString(),
    };
    postContributionRates(
      props.investorId,
      props.isSelectedItem?.potId,
      payload,
    );
  };
  const decimalPart = props.isSelectedItem?.salarySacrificeFlag
    ? Math.round(
        (parseFloat(
          (
            (
              Number(props.isSelectedItem?.potPercentage) +
              Number(props.isSelectedItem?.salarySacrificePercentage)
            ).toFixed(2) % 1
          ).toFixed(2),
        ) *
          100) %
          10,
      ) //eslint-disable-line
    : Math.round(
        (parseFloat(
          (Number(props.isSelectedItem?.potPercentage).toFixed(2) % 1).toFixed(2) //eslint-disable-line
        ) *
          100) %
          10,
      ); //eslint-disable-line

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      props.setSummaryModalShow(false);
      props.setShowConfirm(true);
    }
  }, [data]);

  if (fetching) {
    return <LoadingSpinner />;
  }
  return (
    <div className="summary-changes-modal-container">
      <Headings pageTitle={props.modalTitle} popupTitle={true} />
      <div className="sub-container mt-3">
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="contribute-head mb-2 mt-2">
              {props.avc
                ? "Additional voluntary contributions"
                : "You contribute"}
            </p>
          </Col>
        </Row>
        {props.avc ? (
          <>
            <Row>
              {props.isSelectedItem?.avcPercentage ? (
                <>
                  <Col lg={2} md={6} sm={6} xs={6}>
                    <p className="contribute-sub-head">Allocation</p>
                  </Col>
                  <Col
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="text-end allocation-value"
                  >
                    <p>
                      <span className="prev-value">
                        {Number(props.isSelectedItem?.avcPercentage).toFixed(2)}
                        %
                      </span>
                      <Icons
                        iconname="chevron-large-right"
                        variant="icon-sixteen-px"
                      />{" "}
                      <span className="changed-value">
                        {props.avcPercentageValue}%
                      </span>{" "}
                    </p>
                  </Col>
                  <Col lg={1}></Col>
                  <Col lg={3} md={6} sm={6} xs={6}>
                    <p className="contribute-sub-head">
                      Estimated monthly contribution
                    </p>
                  </Col>
                  <Col lg={4} md={6} sm={6} xs={6} className="text-end">
                    <p className="rc-allocation">
                      <span className="prev-value">
                        £
                        {addCommas(
                          Math.floor(Number(initialAVContributionValue)),
                        )}
                      </span>
                      <Icons
                        iconname="chevron-large-right"
                        variant="icon-sixteen-px"
                      />{" "}
                      <span className="changed-value">
                        £
                        {addCommas(
                          Math.floor(Number(props.aVContributionValue)),
                        )}
                      </span>{" "}
                    </p>
                  </Col>
                </>
              ) : (
                <>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <p className="contribute-sub-head">
                      Estimated monthly contribution
                    </p>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6} className="text-end">
                    <p className="avc-allocation">
                      <span className="prev-value">
                        £
                        {addCommas(
                          Math.floor(Number(initialAVContributionValue)),
                        )}
                      </span>
                      <Icons
                        iconname="chevron-large-right"
                        variant="icon-sixteen-px"
                      />{" "}
                      <span className="changed-value">
                        £
                        {addCommas(
                          Math.floor(Number(props.aVContributionValue)),
                        )}
                      </span>{" "}
                    </p>
                  </Col>
                </>
              )}
            </Row>
          </>
        ) : (
          <>
            <Row>
              <Col lg={2} md={6} sm={6} xs={6}>
                <p className="contribute-sub-head">Allocation</p>
              </Col>
              <Col
                lg={2}
                md={6}
                sm={6}
                xs={6}
                className="text-end allocation-value"
              >
                <p>
                  {props.isSelectedItem?.salarySacrificeFlag ? (
                    <span className="prev-value">
                      {decimalPart === 0
                        ? (
                            Number(props.isSelectedItem?.potPercentage) +
                            Number(
                              props.isSelectedItem?.salarySacrificePercentage //eslint-disable-line
                            )
                          ).toFixed(2)
                        : (
                            Number(props.isSelectedItem?.potPercentage) +
                            Number(
                              props.isSelectedItem?.salarySacrificePercentage //eslint-disable-line
                            )
                          ).toFixed(2)}
                      %
                    </span>
                  ) : (
                    <span className="prev-value">
                      {Number(props.isSelectedItem?.potPercentage).toFixed(2)}%
                    </span>
                  )}
                  <Icons
                    iconname="chevron-large-right"
                    variant="icon-sixteen-px"
                  />{" "}
                  {props.isSelectedItem?.salarySacrificeFlag ? (
                    <span className="changed-value">
                      {props.salarySacrificeContribution}%
                    </span>
                  ) : (
                    <span className="changed-value">
                      {props.contributionValue}%
                    </span>
                  )}
                </p>
              </Col>
              <Col lg={1}></Col>
              <Col lg={3} md={6} sm={6} xs={6}>
                <p className="contribute-sub-head">
                  Estimated monthly contribution
                </p>
              </Col>
              <Col lg={4} md={6} sm={6} xs={6} className="text-end">
                <p className="rc-allocation">
                  <span className="prev-value">
                    £{addCommas(Math.floor(Number(initialYouContribPice)))}
                  </span>
                  <Icons
                    iconname="chevron-large-right"
                    variant="icon-sixteen-px"
                  />{" "}
                  <span className="changed-value">
                    £{addCommas(Math.floor(Number(props.youContributePrice)))}
                  </span>{" "}
                </p>
              </Col>
            </Row>
          </>
        )}
        {!props.gradeException ? (
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Row>
          <Col>
            <p className="contribute-head mb-2 mt-2">
              {props.avc
                ? "Your regular contributions"
                : !props.gradeException
                  ? "Your employer contributes"
                  : ""}
            </p>
          </Col>
        </Row>
        {props.avc ? (
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p className="contribute-sub-head">
                Estimated monthly contribution
              </p>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6} className="text-end">
              <p className="avc-allocation">
                <span className="prev-value">
                  £{addCommas(Math.floor(Number(initialTotalContribution)))}
                </span>
                <Icons
                  iconname="chevron-large-right"
                  variant="icon-sixteen-px"
                />{" "}
                <span className="changed-value">
                  £{addCommas(Math.floor(Number(initialTotalContribution)))}
                </span>{" "}
              </p>
            </Col>
          </Row>
        ) : !props.gradeException ? (
          <>
            <Row>
              <Col lg={2} md={6} sm={6} xs={6}>
                <p className="contribute-sub-head">Allocation</p>
              </Col>
              <Col
                lg={2}
                md={6}
                sm={6}
                xs={6}
                className="text-end allocation-value"
              >
                <p>
                  <span className="prev-value">
                    {Number(props.isSelectedItem?.potErPercentage).toFixed(2)}%
                  </span>
                  <Icons
                    iconname="chevron-large-right"
                    variant="icon-sixteen-px"
                  />{" "}
                  <span className="changed-value">
                    {Number(props.contributionErValue).toFixed(2)}%
                  </span>{" "}
                </p>
              </Col>
              <Col lg={1}></Col>
              <Col lg={3} md={6} sm={6} xs={6}>
                <p className="contribute-sub-head">
                  Estimated monthly contribution
                </p>
              </Col>
              <Col lg={4} md={6} sm={6} xs={6} className="text-end">
                <p className="rc-allocation">
                  <span className="prev-value">
                    £{addCommas(Math.floor(Number(initialEmpContribPrice)))}
                  </span>
                  <Icons
                    iconname="chevron-large-right"
                    variant="icon-sixteen-px"
                  />{" "}
                  <span className="changed-value">
                    £
                    {addCommas(Math.floor(Number(props.yourEmpContributPrice)))}
                  </span>{" "}
                </p>
              </Col>
            </Row>
          </>
        ) : (
          ""
        )}
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="contribute-head mb-1 mt-2">
              Estimated cost to you (example 20%, your tax rate may be higher or
              lower)
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="est-cost mb-1">
              <span className="prev-value">
                £
                {props.avc
                  ? addCommas(Math.floor(Number(initialYouPayAVCValue)))
                  : addCommas(Math.floor(Number(initialYouPayValue)))}
              </span>
              <Icons iconname="chevron-large-right" variant="icon-sixteen-px" />{" "}
              <span className="changed-value">
                £
                {props.avc
                  ? addCommas(Math.floor(Number(props.youPayAVCValue)))
                  : addCommas(Math.floor(Number(props.youPayValue)))}
              </span>{" "}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="contribute-head mb-1 mt-2">You receive</p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="est-cost mb-1">
              <span className="prev-value">
                £
                {props.avc
                  ? //prettier-ignore
                    addCommas(
                      Math.floor(Number(initialTotalAVContributionPrice))
                    )
                  : addCommas(Math.floor(Number(initialTotalContribution)))}
              </span>
              <Icons iconname="chevron-large-right" variant="icon-sixteen-px" />{" "}
              <span className="changed-value">
                £
                {props.avc
                  ? addCommas(
                      Math.floor(Number(props.totalAVContributionPrice)),
                    )
                  : addCommas(Math.floor(Number(props.totalContributionPrice)))}
              </span>{" "}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        {props.avc ? (
          ""
        ) : (
          <>
            <Row>
              <Col lg={12} className="text-end">
                <p className="salary-sacrifice-head mb-2 mt-2">
                  Making salary sacrifice?{" "}
                  <span>
                    {props.isSelectedItem?.salarySacrificeFlag ? "Yes" : "No"}
                  </span>
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr />
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col lg={5}>
            <p className="notify-msg-employer mb-2 mt-2">
              We will ask your employer to make this change from{" "}
              {contributionEffectiveDateMonthYear()}
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="summary-modal-action-btns text-end">
            <Buttons
              className="secondary me-2"
              handleClick={props.handleCloseButton}
              name="Cancel"
            />
            {fetching ? (
              <div className="loading-spinner-loader"></div>
            ) : (
              <Buttons
                className="primary"
                handleClick={handleSubmit}
                name="Submit"
              />
            )}
          </Col>
        </Row>
      </div>
      {error ? alert(error) : ""}
    </div>
  );
};

export default SummaryOfChangesModal;
